/**
 *                                          __  __
 *    ____  ______      ______ _      __   / /_/ /_  ___  ____ ___  ___
 *   / __ \/ ___/ | /| / / __ \ | /| / /  / __/ __ \/ _ \/ __ `__ \/ _ \
 *  / / / (__  )| |/ |/ / /_/ / |/ |/ /  / /_/ / / /  __/ / / / / /  __/
 * /_/ /_/____/ |__/|__/\____/|__/|__/   \__/_/ /_/\___/_/ /_/ /_/\___/
 *
 * ns.wow WordPress theme
 * by Neidhart + Schön Group
 */

// Bundle theme module (NSTheme)

import Helper from './Classes/Helper';
import FocusHandler from './Classes/FocusHandler';
import LazyLoad from 'vanilla-lazyload';
import ResponsiveTable from "./Classes/ResponsiveTable";
import XDownloader from "./Classes/XDownloader";
import CountUpNumbers from './Classes/CountUpNumbers';

import Accordion from './Classes/Accordion';
// import Jump from './Classes/Jump'
// import Sticky from '../../node_modules/sticky-js';
// import YoutubeLinks from './Classes/YoutubeLinks';
import Swiper from "./lib/swiper";
import SliderHandler from './Classes/SliderHandler';
import Header from './Classes/Header';
import ToTop from './Classes/ToTop';
import PrintHandler from './Classes/PrintHandler';
// import Sticky from '../../node_modules/sticky-js';

var focusHandlerInstance = null;
var lazyLoadInstance = null;
var responsiveTableInstance = null;
var downloaderInstance = null;

var accordionInstance = null;
var jumpInstance = null;
var youtubeLinksInstance = null;

var countUpInstance = null;
var swiperInstance = null;
var sliderHandlerInstance = null;
var headerInstane = null;
var toTopInstance = null;
var printHandlerInstance = null;

export default {

  version: () => {
    return NSContext.theme.version;
  },

  lazyload: (givenNodeset) => {
    lazyLoadInstance.update(givenNodeset);
  }

  // addYoutubeLink: (videoContainer) => {
  //   youtubeLinksInstance.addLink(videoContainer);
  // }

};


// Initialize on document ready

document.addEventListener("DOMContentLoaded", function () {

  focusHandlerInstance = new FocusHandler();

  window.imagesLoadedForPrint = false;
  var finishLoadHandler = () => {
    window.imagesLoadedForPrint = true;
  }

  lazyLoadInstance = new LazyLoad({
    callback_finish: finishLoadHandler
  });

  printHandlerInstance = new PrintHandler({
    lazyLoadInstance: lazyLoadInstance,
  });


  // Highcharts.setOptions({
  //   lang: {
  //     decimalPoint: '.', // default: '.'
  //     numericSymbols: null, // default: ["k", "M", "G", "T", "P", "E"], set to null to see full numbers
  //     thousandsSep: '’', // default: '\u0020'
  //     shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], // default: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
  //   }
  // });

  responsiveTableInstance = new ResponsiveTable({
    tableSelector: '.ns-table-wrap table',
    tableWrapperSelector: '.ns-table-wrap',
    breakPointLg: 1200,
    breakPointMd: 768,
    breakPointSm: 480,
    colCountNoSplit: 3,
    colCountEarlyBreak: 7,
    noSplitArray: []
  });


  // downloaderInstance = new XDownloader({
  //   downloadText: "Download Excel", //Can be empty if you want to use an icon instead
  //   backgroundColor: "6ab04c", //Colored Cells Background
  //   backgroundClass: 'ns-backgroundcolor-gf_3a-green', //Class of colored cells
  //   borderColor: '95afc0', //Color of border
  //   borderStyle: 'thin', // thin/dotted/medium/double/thick
  //   headClass: 'head', //Class you want your columns based on. Will be bold in Excel
  //   boldClass: 'title', //Class for Bold text in Excel
  //   borderClass: 'ns-borderbottom-line_dots'
  // });

  accordionInstance = new Accordion({
    accordions: '.ns-accordion__head',
    pxCorrection: 0
  });


  // jumpInstance = new Jump({
  //   graphicSelector: '.ns-graphic'
  // });

  // youtubeLinksInstance = new YoutubeLinks({
  // });

  countUpInstance = new CountUpNumbers({
    numbersSelector: '.ns-keyfigures__number',
    classIn: 'is-in-viewport',
    classOut: 'is-not-in-viewport',
    langArray: ['de-DE', 'en-US'],
    decimalArray: ['.', '.'],
    thousandSepArray: ['’', '’'],
  });

  // swiperInstance = new Swiper('.swiper', {
  //   //loop: true,
  //   spaceBetween: 36,
  //   slidesPerView: 3,
  //   centeredSlides: false,
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   }
  // });

  sliderHandlerInstance = new SliderHandler({
    outerWrapperSelector: '.ns-slider'
  });

  headerInstane = new Header({
    headerSelector: '.wp-header',
    burgerSelector: '.wp-header-menu__burger',
    navigationSelector: '.wp-header-menu-navigation',
    navItemSelector: '.menu__item--has-children .menu__link--level-0',
    initialActiveItemSelector: '.menu__item--level-0.menu__item--ancestor-active',
  });

  toTopInstance = new ToTop({ minScrollVisible: 200 });


  let SiteMapSelectToggClass = [...document.querySelectorAll('.dropdownstiemap')];

  SiteMapSelectToggClass.forEach((el) => {
    el.addEventListener("click", (e) => {
      if (el.classList.contains("is-active")) {
        el.classList.remove('is-active');
      } else {
        el.classList.add('is-active');
      }
    });
  });
});

